import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import extend from 'lodash/extend';

import { OUTLETS_MAP_CONTEXT } from '@cakeiteasy/web-ui';
import { OutletScheduleOverridesFacadeService } from '@cakeiteasy/order-process';

import { IMpOutlet } from '@shared/models/outlet/i-mp-outlet';
import { UiContextService } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  templateUrl: './outlets-map-modal.component.html',
  styleUrls: ['./outlets-map-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'outlets-map-modal' }
})
export class OutletsMapModalComponent implements OnInit {
  public outlets: IMpOutlet[] = [];
  public outletsSubset: IMpOutlet[] = [];
  public defaultConfig = {
    isShowAll: null,
    mapContext: OUTLETS_MAP_CONTEXT.FOR_BAKERY,
    showHeader: true,
    isOutletSelectionStateEnabled: false
  };

  public config: {
    isShowAll: boolean,
    mapContext: string,
    showHeader: boolean,
    isOutletSelectionStateEnabled: boolean
  };

  constructor(public uiContext: UiContextService,
              public modal: NgbActiveModal,
              public outletScheduleOverrides: OutletScheduleOverridesFacadeService) {
  }

  ngOnInit() {
    this.config = extend({}, this.defaultConfig, this.config);

    if (this.config.isShowAll === null) {
      this.config.isShowAll = !Boolean(this.outletsSubset);
    }
  }
}
